(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shoppable-marquee')) {
    class ShoppableMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.group = this.querySelector('[data-group]');
        if (!this.track || !this.group) return;

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this._onClick = this.onClick.bind(this);
        this._onDocClick = (e) => { if (!this.contains(e.target)) this.closePopovers(); };
        this._onKey = (e) => { if (e.key === 'Escape') this.closePopovers(true); };

        this.addEventListener('click', this._onClick);
        document.addEventListener('click', this._onDocClick);
        document.addEventListener('keydown', this._onKey);

        let t;
        this._ro = new ResizeObserver(() => {
          clearTimeout(t);
          t = setTimeout(() => this.build(), 150);
        });
        this._ro.observe(this);
        this._ro.observe(this.group);

        // play videos only while the strip is on screen
        this._io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.syncVideos();
        }, { threshold: 0.05 });
        this._io.observe(this);

        this.build();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        document.removeEventListener('click', this._onDocClick);
        document.removeEventListener('keydown', this._onKey);
        this._ro && this._ro.disconnect();
        this._io && this._io.disconnect();
      }

      /* ---------- Marquee ---------- */
      build() {
        this.track.querySelectorAll('[data-clone]').forEach((n) => n.remove());
        const groupW = this.group.getBoundingClientRect().width;
        if (!groupW || this.reduced) return;

        const viewport = this.clientWidth || window.innerWidth;
        const copies = Math.max(1, Math.ceil(viewport / groupW));

        for (let i = 0; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.removeAttribute('data-group');
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
        }

        const speed = parseFloat(this.dataset.speed) || 40; // px per second
        this.style.setProperty('--ssm-distance', groupW + 'px');
        this.style.setProperty('--ssm-duration', (groupW / speed).toFixed(2) + 's');
        this.classList.add('is-ready');
        this.syncVideos();
      }

      syncVideos() {
        this.querySelectorAll('video').forEach((v) => {
          if (this.visible === false) v.pause();
          else { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
        });
      }

      /* ---------- Interactions (delegated so clones work too) ---------- */
      onClick(e) {
        const opt = e.target.closest('[data-variant]');
        if (opt) return this.selectVariant(opt);

        const toggle = e.target.closest('[data-toggle]');
        if (toggle) return this.togglePopover(toggle.closest('.ssm__card'));

        const atc = e.target.closest('[data-atc]');
        if (atc) return this.add(atc);
      }

      togglePopover(card) {
        const pop = card.querySelector('[data-popover]');
        const btn = card.querySelector('[data-toggle]');
        const open = pop.hidden;
        this.closePopovers();
        pop.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        this.classList.toggle('is-paused', open);
        if (open) {
          const sel = pop.querySelector('[aria-selected="true"]:not(:disabled)') || pop.querySelector('button:not(:disabled)');
          sel && sel.focus({ preventScroll: true });
        }
      }

      closePopovers(returnFocus) {
        this.querySelectorAll('[data-popover]:not([hidden])').forEach((p) => {
          p.hidden = true;
          const btn = p.closest('.ssm__card').querySelector('[data-toggle]');
          if (btn) { btn.setAttribute('aria-expanded', 'false'); if (returnFocus) btn.focus(); }
        });
        this.classList.remove('is-paused');
      }

      selectVariant(opt) {
        const card = opt.closest('.ssm__card');
        card.dataset.variantId = opt.dataset.id;
        card.querySelectorAll('[data-variant]').forEach((o) =>
          o.setAttribute('aria-selected', String(o === opt))
        );
        const label = card.querySelector('[data-variant-label]');
        if (label) label.textContent = opt.dataset.title;
        const price = card.querySelector('[data-price]');
        if (price) price.textContent = opt.dataset.price;
        this.closePopovers();
      }

      setLabel(btn, text) {
        const el = btn.querySelector('[data-atc-label]');
        if (el) el.textContent = text;
      }

      async add(btn) {
        if (btn.dataset.loading === 'true') return;
        const card = btn.closest('.ssm__card');
        const id = Number(card.dataset.variantId);
        if (!id) return;

        btn.dataset.loading = 'true';
        this.setLabel(btn, this.dataset.labelAdding);

        let ok = false;
        let message = '';
        try {
          const data = await this.request(id);
          await this.refreshCart(data);
          ok = true;
        } catch (err) {
          message = err && err.message ? err.message : 'Error';
        }

        this.setLabel(btn, ok ? this.dataset.labelAdded : message);
        setTimeout(() => {
          btn.dataset.loading = 'false';
          this.setLabel(btn, this.dataset.labelAdd);
        }, ok ? 1400 : 2600);
      }

      /* ---------- Cart ---------- */
      get dawnDrawer() {
        const d = document.querySelector('cart-drawer');
        return d && typeof d.getSectionsToRender === 'function' && typeof d.renderContents === 'function' ? d : null;
      }

      async request(variantId) {
        const payload = { items: [{ id: variantId, quantity: 1 }] };
        const drawer = this.dawnDrawer;
        if (drawer) {
          payload.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
          payload.sections_url = window.location.pathname;
        }
        const res = await fetch(this.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not add');
        }
        return data;
      }

      async refreshCart(data) {
        // 1) Dawn-style <cart-drawer>: re-render + open it natively
        const drawer = this.dawnDrawer;
        if (drawer && data.sections) {
          drawer.renderContents(data);
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shoppable-marquee', cartData: data });
            }
          } catch (e) {}
          return;
        }

        // 2) Generic themes: re-fetch drawer section, fire common events, click the cart icon
        const sectionId = (this.dataset.cartSection || '').trim();
        if (sectionId) {
          try {
            const r = await fetch(`${this.dataset.rootUrl}?sections=${encodeURIComponent(sectionId)}`);
            const json = await r.json();
            const html = json[sectionId];
            const target = document.getElementById('shopify-section-' + sectionId);
            if (html && target) {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.getElementById('shopify-section-' + sectionId);
              target.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
            }
          } catch (e) {}
        }

        let cart = null;
        try { cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) {}

        ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build', 'cart:item-added', 'product:added', 'ajaxProduct:added', 'cart.requestComplete']
          .forEach((name) => {
            const ev = new CustomEvent(name, { bubbles: true, detail: { cart, item: data, source: 'shoppable-marquee' } });
            document.dispatchEvent(ev);
            window.dispatchEvent(new CustomEvent(name, { detail: { cart, item: data, source: 'shoppable-marquee' } }));
          });

        await new Promise((r) => setTimeout(r, 200));

        const selector = (this.dataset.openSelector || '').trim();
        const opener = selector ? document.querySelector(selector) : null;
        if (opener) {
          opener.click();
        } else if (this.dataset.redirect === 'true') {
          window.location.href = this.dataset.cartUrl;
        }
      }
    }
    customElements.define('shoppable-marquee', ShoppableMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spirits-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spirit-collections')) {
    class SpiritCollections extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.sc-card'));

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const inEditor = window.Shopify && window.Shopify.designMode;

        // Theme editor: reveal a block when it's selected in the sidebar
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('.sc-card');
          if (card) card.classList.add('is-visible');
        });

        if (this.dataset.animate !== 'true' || reduceMotion || inEditor) return;
        if (!('IntersectionObserver' in window)) return;

        this.classList.add('sc--animate');

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
        );

        this.cards.forEach((card, index) => {
          card.style.setProperty('--sc-delay', `${(index % 5) * 80}ms`);
          this.observer.observe(card);
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('spirit-collections', SpiritCollections);
  }

  } catch(e) { console.error(e); }
})();
})();
